<template>
    <div class="hanzo-info">
      {{ info }}
    </div>
</template>
<script>
export default {
    name: 'h-info',
    props: {
        info: String | Number
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
